import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import safeAreaInsets from 'safe-area-insets';
import { clearAllStores } from '@/helpers/store-reset-helper';
import { AuthenticatedUser, LogoutCommand } from '@/application/authentication/types';
import { UserAction } from '@/application/types';
import { showError } from '@/application/snackbar/service';
import { Feature } from '@/helpers/data';
import ProductSearch from '@/domain/product-search/components/product-search/product-search.vue';
import OrderSearch from '@/domain/order-search/components/order-search/order-search.vue';
import ProjectSearch from '@/domain/project-search/components/project-search/project-search.vue';

const appState = namespace('app');
const authenticationState = namespace('authentication');

@Component({
  components: {
    ProductSearch,
    OrderSearch,
    ProjectSearch,
  }
})
export default class AppHeader extends Vue {

  @authenticationState.Getter
  readonly isFeatureEnabled!: (feature: Feature) => boolean;

  @authenticationState.State
  readonly isAuthenticated!: boolean;

  @authenticationState.State
  readonly user!: AuthenticatedUser;

  @appState.State
  readonly title!: string;

  @authenticationState.Action
  readonly logout!: UserAction<LogoutCommand>;

  @authenticationState.Getter
  readonly isAdmin!: () => boolean;

  @appState.Mutation
  readonly updateTitle!: (title?: string) => void;

  toolbarHeight = 60;
  navigationDrawerWidth = 230;
  mobileBreakPoint = 1024;
  navigationDrawerVisible = false;
  navigationDrawerExpandOnHover = false;

  get isDomainVisible(): boolean {
    return this.isAuthenticated;
  }

  beforeMount() {
    window.addEventListener('resize', this.handleResize);

    if (window.innerWidth > 1023) {
      this.navigationDrawerVisible = true;
      this.navigationDrawerExpandOnHover = true;
    } else {
      this.navigationDrawerVisible = false;
      this.navigationDrawerExpandOnHover = false;
    }
  }

  mounted() {
    this.calculateSafeAreas();

    safeAreaInsets.onChange(() => this.calculateSafeAreas());

    this.onRoutePathChanged();
  }

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }

  @Watch('$route.path')
  onRoutePathChanged() {
    this.updateTitle(this.$route.meta.title);
  }

  public handleResize() {
    if (window.innerWidth > 1023) {
      this.navigationDrawerExpandOnHover = true;
    } else if (window.innerWidth < 1024) {
      this.navigationDrawerExpandOnHover = false;
    }
  }

  public onLogout(): void {
    const command: LogoutCommand = {};

    this.logout(command)
      .catch((error) => {
        const message = error.response?.data.message || 'Die Abmeldung konnte nicht ausgeführt werden';
        showError({ message });
      })
      .finally(() => {
        clearAllStores();
        this.$router.push({ name: 'root' });
      });
  }

  private calculateSafeAreas(): void {
    this.toolbarHeight = 60 + safeAreaInsets.top;
    this.navigationDrawerWidth = 230 + safeAreaInsets.left;
  }

}
